<template>
  <div
    class="c-product-card card h-100"
    :class="wrapperClasses"
  >
    <div
      v-if="$slots.image"
      class="card__image"
    >
      <slot name="image"/>
    </div>

    <div class="card__content">
      <div class="card__row">
        <div class="heading-5">
          <span v-html="title"></span>
        </div>

        <div
          v-if="$slots.teaser"
          class="c-product-card__teaser text-muted"
        >
          <slot name="teaser"/>
        </div>

        <div class="c-product-card__price">
          {{ price }}
        </div>
      </div>

      <p class="paragraph-small">
        <slot name="description"/>
      </p>

      <div
        v-if="$slots.actions"
        class="card-actions"
      >
        <slot name="actions"/>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import Component from "vue-class-component";
import {Prop} from "vue-property-decorator";

@Component
export default class ProductCard extends Vue {
  @Prop()
  title!: string;

  @Prop()
  price!: string;

  @Prop({
    default: () => false
  })
  isActive!: boolean;

  get wrapperClasses() {
    return {
      "c-product-card--active": this.isActive
    };
  }
}
</script>

<style lang="scss" scoped>
.c-product-card {
  &__price {
    color: $blue;
    font-weight: bold;
  }

  &--active {
    border-color: $primary;
    box-shadow: 0 0 0 3px rgba($primary, 0.3);
  }
}

.card {
  border: 1px solid rgba(200, 207, 216, 0.5);
  border-radius: 6px;
  transition: 0.2s ease-out;

  &__image {
    padding-top: 55%;
    position: relative;

    img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
      border-radius: 5px 5px 0 0;
    }
  }

  &__content {
    padding: 1rem;
  }

  &__row {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    margin-bottom: 1rem;

    & > * {
      margin-bottom: 0.75rem;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}

.card-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;

  & > * {
    margin-right: 1rem;
    margin-top: 0.5rem;

    &:last-child {
      margin-right: 0;
    }
  }
}

@keyframes skeleton-blinking {
  0% {
    opacity: 0.5;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.5;
  }
}

.card.card--skeleton {
  .card__image {
    background-color: rgba(200, 207, 216, 0.5);
    animation: skeleton-blinking 2s infinite;
  }

  .card__content {
    &:before {
      height: 1.5rem;
      width: 100%;
      margin-bottom: 0.75rem;
      display: block;
      content: '';
      background-color: rgba(200, 207, 216, 0.5);
      border-radius: 4px;

      animation: skeleton-blinking 2s infinite;
      animation-delay: 0.25s;
    }

    &:after {
      background-color: rgba(200, 207, 216, 0.5);
      width: 100%;
      height: 4rem;
      content: '';
      border-radius: 4px;
      animation: skeleton-blinking 2s infinite;
      animation-delay: 0.5s;
    }
  }
}
</style>
